import React from 'react'

const Manual_menu_modificadores_precios_multiples = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
        <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
            Menú - Modificadores Precios Múltiples
        </h2>
        <p className="text-lg text-gray-700 mb-6">
            Esta guía explica cómo añadir múltiples opciones de precio a los modificadores del menú, mejorando su flexibilidad y la experiencia del cliente. Detalla los pasos para actualizar precios según el tipo de pedido, optimizando la gestión del menú y las estrategias de venta.
        </p>
        <iframe
            src="https://scribehow.com/embed/Menu__Modificadores_Precios_Multiples__IQbBmacFRRCFlHEO8J9RHg?as=scrollable"
            className="scribe-iframe-general-32"
            width="100%"
            height="4150"
            allowFullScreen
            style={{ border: 0, minHeight: '640px' }}
        ></iframe>
        </div>
    </div>
  )
}

export default Manual_menu_modificadores_precios_multiples